import { makeCommonStore, FormField } from '../commons'
import CustomerService from '@/services/CustomerService'

const store = {
  ...makeCommonStore(
    {
      service: CustomerService,
      fields: [
        new FormField({
          name: 'id',
          hidden: true
        }),
        new FormField({
          name: 'name',
          label: 'Customer name *',
          icon: 'description',
          rules: [ 'required' ],
          md: 12
        }),
        new FormField({
          name: 'address',
          type: 'address',
          value: '',
          label: 'Address *',
          rules: [ 'required' ],
          text: '',
          md: 12
        }),
        new FormField({
          name: 'email',
          label: 'Email',
          rules: [ 'email' ],
          icon: 'email',
          md: 12
        }),
        new FormField({
          name: 'phone',
          label: 'Phone',
          icon: 'phone',
          md: 12
        }),
        new FormField({
          name: 'description',
          type: 'textarea',
          label: 'Description',
          icon: 'description',
          md: 12
        })
      ]
    },
    ['fields']
  ),
  namespaced: true
}

export default store
